































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import SignInForm from '@/components/signIn/SignInForm.vue'
import SignUpForm from '@/components/signUp/SignUpForm.vue'
import Dashboard from '@/components/dashboard/Dashboard.vue'
import LangSwitcher from '@/components/common/layout/LangSwitcher.vue'
import UserService from '@/services/UserService'

@Component({
  name: 'HomePage',
  components: {
    SignInForm,
    SignUpForm,
    LangSwitcher,
    Dashboard
  }
})
export default class HomePage extends Vue {
  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean

  @Prop({ default: '' })
  message?: string

  tabIndex: number = 0
  signInLinkId = 'sign-in-link-in-home'

  async mounted () {
    let signInLink = document.querySelector(`#${this.signInLinkId}`)
    if (signInLink) {
      signInLink.addEventListener('click', (): void => { this.changeForm('signIn') })
    }

    let impersonateUser = this.$route.query.impersonate_user
    let impersonateToken = this.$route.query.token
    let shouldImpersonate = Boolean(impersonateUser && impersonateToken)

    if (shouldImpersonate) {
      let refreshImpersonate = this.$auth.isAuthenticated()

      if (refreshImpersonate) {
        await this.$auth.logout()
        await UserService.logout()
      }

      let query = Object.assign({}, this.$route.query)
      delete query.impersonate_user
      delete query.token
      await this.$router.replace({ query })

      let response = await UserService.impersonate(String(impersonateToken), String(impersonateUser))
      await this.$auth.setToken(response)
      await UserService.completeLogin()
      this.$store.commit('user/impersonated')
    }
  }
  changeForm (formName: string) {
    if (formName === 'signIn') {
      this.tabIndex = 1
    } else {
      this.tabIndex = 0
    }
  }
}
